export default {
  day: 'Day',
  fileSizeLimitTitle: 'The file size cannot exceed 20MB in free version.',
  freeTimesLimitTitle: 'The free trial has run out today.',
  total: 'Total',
  enterCode: 'Enter code',
  signUpToPurchaseBtn: 'Sign Up to Purchase',
  goPurchseBtn: 'Go to Purchase',
  saveTips: 'Save Up to {{num}}%',
  discount: 'Discount',
  weekly: 'Weekly',
  montly: 'Monthly',
  yearly: 'Yearly',
  week: 'Week',
  priceWeek: '$9.99',
  priceMonth: '$7.49',
  priceYearly: '$3.75',
  billMonth: '$29.99 Billed Monthly',
  billYear: '$179.99 Billed Annually',
  AlreadySubscribe: 'Already subscribed?',
  vipTips1: 'No file size limits',
  vipTips2: 'No limit to the number of files processed',
  vipTips3: 'Change image backgrounds without limits',
  vipTips4: 'Access to all free tools & premium features',
  purchaseTips: 'Renew automatically and cancel any time.',
  tips: 'Tips',
  promoCodeInvalidTips: 'Your promo code is invalid',
};
